import { FC, ReactNode, createContext } from 'react'
import { InterpreterFrom } from 'xstate'
import { createLocgMachine } from '@app/code/src/machines/locg/locgMachine'
import { useSetupLocgService } from '@app/code/src/machines/locg/useSetupLocgService'

export interface GlobalXStateContextType {
  locgService: InterpreterFrom<ReturnType<typeof createLocgMachine>>
}

export const GlobalXStateContext = createContext<GlobalXStateContextType | undefined>(undefined)

export const XStateProvider: FC<{ children: ReactNode; isMobile?: boolean }> = ({
  children,
  isMobile
}) => {
  const locgService = useSetupLocgService({ isMobile })

  return (
    <GlobalXStateContext.Provider value={{ locgService }}>{children}</GlobalXStateContext.Provider>
  )
}
